import React, { useState,useEffect} from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import close from "./close.png"
import { useSelector, useDispatch } from "react-redux";
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl, Checkbox, FormControlLabel,
  Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import styles from "./PageTitle.module.css"
import jwt_decode from 'jwt-decode'
import axiosInstance from '../../helpers/axios';
import * as moment from 'moment'
import Dropzone from "react-dropzone";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { useUserAuth } from '../../views/auth/AuthContext.js';
import DeleteIcon from "@mui/icons-material/Delete";
import aadhaar from "../../assets/images/aadhaar.png";
import pan from "../../assets/images/pan-card-image.png";
import bs from "../../assets/images/bs.png";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxHeight: "100vh",
  overflow:'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '10px',
  p: 4,
};

const formHeader = {
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  display: 'flex',
  flexDirection: 'row',
  padding: '20px',
  justifyContent: 'space-between',
  bgcolor: '#E9E9E9',
  height: '50px',
  alignItems: 'center',
};

const scrollableBody = {
  overflowY: 'scroll',
  height: '35rem',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};




export default function EditForm({curruser,formOpen,setFormOpen,prodArray,userData}) {
  const location=useLocation();
  const [isFeemonk, setIsFeemonk] = useState(true);
  useEffect(()=>{
    const host = typeof window !== "undefined" ? window.location.host : '';
    const subdomain = host.split('.')[1];
    const isFeemonk = subdomain === "feemonk";
    setIsFeemonk(isFeemonk)
  })

 
  const [instituteName, setInstituteName] = useState('');
  const [courseName, setCourseName] = useState('');
  const [courseFees, setCourseFees] = useState('');
  const [email, setEmail] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState('');
  const [salary, setSalary] = useState('');
  const [studentName, setStudentName] = useState('');
  const [currentAddress, setCurrentAddress] = useState('');
  const [panId, setPanId] = useState('');
  const [currentPincode, setCurrentPincode] = useState('');
  const [currentState, setCurrentState] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const [permanentAddress, setPermanentAddress] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [permanentPincode, setPermanentPincode] = useState('');
  const [permanentState, setPermanentState] = useState('');
  const [permanentCity, setPermanentCity] = useState('');
  const [aadhaarId, setAadhaarId] = useState('');
  const [newFirstName, setNewFirstName] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [newStudentName, setNewStudentName] = useState('');
  const [newMobileNumber, setNewMobileNumber] = useState('');
  const [newCourseFees, setNewCourseFees] = useState('');
  const [newCourseName, setNewCourseName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newAddress, setNewAddress] = useState('');
  const [newCity, setNewCity] = useState('');
  const [newState, setNewState] = useState('');
  const [newPincode, setNewPincode] = useState('');
  const [cra, newCra] = useState([]);
  const maritalOptions = [{label:"Married",value:"Married"},{label:"Single",value:"Single"},{label:"Divorced",value:"Divorced"},{label:"Widowed/Others",value:"Widowed/Others"}]
  const [selectedCRA, setSelectedCRA] = useState('');
  const [tenure,setTenure] = useState("")
  const [newTenure,setNewTenure] = useState("")
  const [productId,setProductId] = useState([])
  const [productCode,setProductCode] = useState("")

  const [aadhaarFront, setAadhaarFront] = useState(null);
  const [aadhaarBack, setAadhaarBack] = useState(null);
  const [panCard, setPanCard] = useState(null);
  const [bankStatement, setBankStatement] = useState(null);
  const [ocrData,setOcrData] = useState([])
  const [Type, setType] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isBankStatementUploaded, setIsBankStatementUploaded] = useState(false);
  const [isSameAsPermanent, setIsSameAsPermanent] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsSameAsPermanent(event.target.checked);
  };

  const handleFileDrop = (setter,type) => (acceptedFiles) => {
     if (acceptedFiles.length > 0) {
    const file = acceptedFiles[0];
    console.log("inside handleFileDrop", type);

    if (type === "pdf" && file.type !== 'application/pdf') {
      setErrorMessage('Only PDF files are allowed for Bank Statement.');
      setter(null);
      setIsBankStatementUploaded(false);
    } else {
      setErrorMessage('');
      setter(file); 
      setType(type);
      if (type !== "pdf") {
        handleSubmission(file, type);
      }else{
        submitUpload(file, type)
      }
      if (type === "pdf") {
        setIsBankStatementUploaded(true);
      }
    }
  }
  };

  const DocCreate = (resp,type) => {
    console.log("inside DocCreate")
    let docData = null;
    if (userData?.userId) {
      if(type!=="driving_license_back"&&type!=="aadhaar_back")
      {
        console.log("inside 1",type)
        docData = {
          userId: userData?.userId,
          type: type==="driving_license_front"||type==="driving_license_back"?"driving_license":type==="aadhaar_front"||type==="aadhaar_back"?"aadhaar":type,
          url1:resp.data.data.s3Url,
          documentPassword:password,
        };
      }
      else if( type==="driving_license_back"||type==="aadhaar_back")
      {
        console.log("inside 2")
         docData = {
          userId: userData?.userId,
          type: type==="driving_license_front"||type==="driving_license_back"?"driving_license":type==="aadhaar_front"||type==="aadhaar_back"?"aadhaar":type,
          url2:resp.data.data.s3Url, 
          documentPassword:password,         
        };
      }

      axios.post(`${process.env.NEXT_PUBLIC_EMI_URL}/users/documents/create/admin`, docData, {
          headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcHBsaWNhdGlvbnMtYmFja2VuZCIsInVzZXJfaWQiOjUsImVtYWlsIjoic2FpcmFta0BmZWVtb25rLmNvbSIsImlhdCI6MTcxNjg3Mzc4NjY5Nywicm9sZSI6ImNybSIsImRpc3BsYXlfbmFtZSI6IlNhaSBSYW0gUmVkZHkiLCJtb2JpbGUiOiI2MzA5MTQ4MzMzIiwiZXhwIjoxNzE2ODc0MzkxNDk3fQ.lPHnxTija-VpfqMzFWfJJ5fkHDkWJYM-kt2ybO7AgA8`,
            'Content-Type': 'application/json',
          },
        })
        .then(
          (res) => {
            // setConfirmationMessage('Uploaded Successfully');
            // setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
            // setTimeout(() => setConfirmationDialog(false), 2000);
            // setTimeout(() => window.location.reload(true), 2000);
          },
          (error) => {
            // setConfirmationMessage('Upload was Unsuccessful...!');
            // setTimeout(() => setConfirmationDialog(!confirmationDialog), 3000);
            // setTimeout(() => setConfirmationDialog(false), 3000);
          },
        );
    } else {
      alert('Fill all mandatory fields');
    }
  };

  const handleSubmission = (item,type) => {
    console.log("inside submission",item,type)
    const data = new FormData();
    data.append('file', item);
    data.append('type', type);
    console.log("data",data)

    if(Type!=="video")
    {
          axios.post(`${process.env.NEXT_PUBLIC_EMI_URL}/file/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
          DocCreate(response,type);
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
    }
    else
    {
          axios.post(`${process.env.NEXT_PUBLIC_EMI_URL}/file/upload-base64`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(
        (response) => {
          DocCreate(response);
        },
        (error) => {
          alert('Check Mandatory Fields and File format');
        },
      );
    }
  
  };
  const submitUpload = async (item,type) => {
    const data = new FormData();
    if (item) {
      data.append("file", item);
    }

    data.append("userId", userData.userId);
    data.append("type", type);
    data.append("applicationId", userData.applicationId);
    data.append("password", password);

    axiosInstance.post(`/bank-statement-analysis/finbox/upload`,data)
    .then((res)=>{
      console.log(res,"hgduysevbdyub")
      if (res.message === "success") {
        console.log(res.message);
      } else{
      }
    }).catch((err)=>{
      console.log(err,"hgduysevbdyub")

      setErrorMessage(err?.response?.data?.message);
      console.log(err)
    })
  };

  const handleFileRemove = (setter) => () => {
    setter(null);
  };

  const [uploadLoading,setUploadLoading] = useState(false)
  const [upload,setUpload] = useState(false)

  const handleUpload =()=>{
    setUploadLoading(true)
    const formdoc = new FormData();
    if (aadhaarFront) formdoc.append('aadhaarFront', aadhaarFront);
    if (aadhaarBack) formdoc.append('aadhaarBack', aadhaarBack);
    if (panCard) formdoc.append('pan', panCard);
    console.log("aadhaarFront",aadhaarFront)
    console.log("aadhaarBack",aadhaarBack)
    console.log("pan",panCard)


    axiosInstance.post(`/ocr/read`,formdoc,{
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
    .then((res)=>{
        axiosInstance.get(`/ocr/data?id=${res?.data?.data?.id}`)
      .then((res)=>{
        setOcrData(res?.data?.data)
        console.log(res?.data?.data)
      }).catch((err)=>{
        console.log(err)
      })
      setUploadLoading(false)
      setUpload(true)
    })
    .catch((err)=>{
      console.log(err)
    })
  }

  console.log("ocrrr",ocrData)
  //const { user } = useUserAuth();
  let user = null;
  let decode=null
  if (typeof sessionStorage !== 'undefined') {
    user = sessionStorage.getItem('user');
    decode=jwt_decode(user)
  } 
  const Id = curruser?.userId;
  const appId=curruser?.applicationId
  const [productType,setProductType]=useState(null)

  useEffect(() => {

   

  //  if(curruser?.userId)
  //   {
  //     const urlProfile = `/summary/user?id=${Id}&applicationId=${appId}&status=${curruser?.status}`;
  //     axiosInstance.get(urlProfile).then((res) => {
  //         setInstituteName(res.data.data.instituteName);
  //         setCourseName(res.data.data.courseName);
  //         setCourseFees(res.data.data.courseFees);
  //         setEmail(res.data.data.email);
  //         setDob(res.data.data.dateOfBirth);
  //         setGender(res.data.data.gender);
  //         setTenure(res?.data?.data?.loanTenure);
  //         setFirstName(res.data.data.firstName);
  //         setLastName(res.data.data.lastName);
  //         setMobile(res.data.data.mobile);
  //         setCurrentAddress(res.data.data.currentAddress);
  //         setOfficeAddress(res.data.data.officeAddress);
  //         setMaritalStatus(res.data.data.maritalStatus);
  //         setStudentName(res.data.data.studentName);
  //         setSalary(res.data.data.salary);
  //         setPanId(res.data.data.panId);
  //         setAadhaarId(res.data.data.aadhaarId);
  //         setCurrentPincode(res.data.data.currentPincode);
  //         setCurrentCity(res.data.data.currentCity);
  //         setCurrentState(res.data.data.currentState);
  //         setOfficePincode(res.data.data.officePincode);
  //         setOfficeCity(res.data.data.officeCity);
  //         setOfficeState(res.data.data.officeState);
  //       });

       
  //   }
   
    const urlProfile = `/products/instituteId/active?instituteId=${decode?.instituteId}`;
    axiosInstance.get(urlProfile,{
      headers:{
        Authorization:`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcHBsaWNhdGlvbnMtYmFja2VuZCIsInVzZXJfaWQiOjUsImVtYWlsIjoic2FpcmFta0BmZWVtb25rLmNvbSIsImlhdCI6MTcxNjg3Mzc4NjY5Nywicm9sZSI6ImNybSIsImRpc3BsYXlfbmFtZSI6IlNhaSBSYW0gUmVkZHkiLCJtb2JpbGUiOiI2MzA5MTQ4MzMzIiwiZXhwIjoxNzE2ODc0MzkxNDk3fQ.lPHnxTija-VpfqMzFWfJJ5fkHDkWJYM-kt2ybO7AgA8`
      }
    })
    .then((res) => {
      setProductId(res?.data?.data)
      })
    .catch((err)=>console.log(err))
  }
 ,[] )

 const [empType,setEmpType]=useState("")
 const [loading, setLoading]=useState(false)
 const [empName,setEmpName]=useState("")
 const [empSalary,setEmpSalary]=useState("")
 const [errors,setErrors]=useState("")
 const [isSaved, setIsSaved] = useState(false);
 const [saveError, setSaveError] = useState('');
 const [emiAmount,setEmiAmount] = useState(null)
 const updateStatusUrl = `/application/assign-fundsource-qec`;

  const updateMobile=`/summary/update`;
  const handleSave=async ()=>{
    setSaveError('');
    setErrors({});  
    const data = {
      applicationId:  userData?.applicationId?userData?.applicationId:appId,
      userId:  userData?.userId?userData?.userId:Id,
      instituteName: instituteName ? instituteName : userData?.instituteName?userData?.instituteName:instituteName, 
      mobile: newMobileNumber ? newMobileNumber :  userData?.mobile?userData?.mobile:mobile ,
      firstName: newFirstName ? newFirstName : userData?.firstName ? userData?.firstName : firstName,
      lastName: newLastName ? newLastName : userData?.lastName ? userData?.lastName : lastName,
      studentName: newStudentName ? newStudentName : studentName,
      courseFees: newCourseFees ? newCourseFees : userData?.courseFees ? userData?.courseFees : courseFees,
      courseName: newCourseName ? newCourseName :  userData?.courseName ? userData?.courseName : courseName,
      dateOfBirth: dob ? moment(dob).format('YYYY-MM-DD') :userData?.dob ? userData?.dob: dob,
      loanTenure: productType ? productType:  '',
      employmentType: empType,
      employerName: empType === "salaried" ? empName : "NA",
      salary: empType === "salaried" ? empSalary : "0",
      incomePerMonth: empType === "self-employed" ? empSalary : "0",
      typeOfBusiness: empType === "self-employed" ? empName : "NA",
      email: newEmail ? newEmail :  userData?.email ? userData?.email: email,
      maritalStatus: maritalStatus,
      
    };

    console.log("dataaaaaaaaaaaaa",data)
    let flag=0
    let tempError={}
    for(var key in data) {

      if(data[key] === "") {
        console.log("key",key)
        console.log("data[key]",data[key])
        flag=1
        tempError[key]="This is a required field"
      }
      // if(key==="courseFees"&&(parseInt(data[key])>35000))
      //   {
      //     flag=1
      //     tempError[key]="This is a required field and should be less than 35000Rs"
      //   }
      setErrors(tempError)
  }
  console.log("flag",flag)
  if(flag!=1)
    { setLoading(true)
      await axiosInstance.post(updateMobile,data,{
        headers:{
          Authorization:`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcHBsaWNhdGlvbnMtYmFja2VuZCIsInVzZXJfaWQiOjUsImVtYWlsIjoic2FpcmFta0BmZWVtb25rLmNvbSIsImlhdCI6MTcxNjg3Mzc4NjY5Nywicm9sZSI6ImNybSIsImRpc3BsYXlfbmFtZSI6IlNhaSBSYW0gUmVkZHkiLCJtb2JpbGUiOiI2MzA5MTQ4MzMzIiwiZXhwIjoxNzE2ODc0MzkxNDk3fQ.lPHnxTija-VpfqMzFWfJJ5fkHDkWJYM-kt2ybO7AgA8`
        }
      })
      .then((res)=>
      {
        setIsSaved(true);
        const urlgetEmi=`/admin/application/emi?applicationId=${userData?.applicationId?userData?.applicationId:appId}&productId=${productCode}`
        axiosInstance.get(urlgetEmi,{
          headers:{
            Authorization:`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcHBsaWNhdGlvbnMtYmFja2VuZCIsInVzZXJfaWQiOjUsImVtYWlsIjoic2FpcmFta0BmZWVtb25rLmNvbSIsImlhdCI6MTcxNjg3Mzc4NjY5Nywicm9sZSI6ImNybSIsImRpc3BsYXlfbmFtZSI6IlNhaSBSYW0gUmVkZHkiLCJtb2JpbGUiOiI2MzA5MTQ4MzMzIiwiZXhwIjoxNzE2ODc0MzkxNDk3fQ.lPHnxTija-VpfqMzFWfJJ5fkHDkWJYM-kt2ybO7AgA8`
          }
        }).then((res)=>{
          setLoading(false)
          console.log("refebfebr",res?.data?.data)
          setEmiAmount(res?.data?.data)
        }).catch((err)=>{
        console.log(err)
      })
    })
    }
    else if(errors.length>0)
    {
      alert(JSON.stringify(errors))
    }

  }

  const updateAddress=`/users/profile-details/create`;

  const handleSubmit=async ()=>{
    if (!isSaved) {
      setSaveError("Please save the details before submitting.");
      return;
    }
    const data = {
      applicationId:  userData?.applicationId?userData?.applicationId:appId,
      userId:  userData?.userId?userData?.userId:Id,
      currentAddress: newAddress ? newAddress :ocrData?.address ? ocrData?.address : currentAddress,
      currentCity: newCity ? newCity :ocrData?.city ? ocrData?.city: currentCity,
      currentState: newState ? newState :ocrData?.state ? ocrData?.state: currentState ,
      currentPincode: newPincode ? newPincode :ocrData?.pincode ? ocrData?.pincode: currentPincode,
      permanentAddress: isSameAsPermanent?ocrData?.address:permanentAddress,
      permanentCity: isSameAsPermanent?ocrData?.city:permanentCity,
      permanentState: isSameAsPermanent?ocrData?.state:permanentState ,
      permanentPincode: isSameAsPermanent?ocrData?.pincode:permanentPincode,
    };

       
    const data1 = {
      applicationId:  userData?.applicationId?userData?.applicationId:appId,
      userId:  userData?.userId?userData?.userId:Id,
      instituteName: instituteName ? instituteName : userData?.instituteName?userData?.instituteName:instituteName, 
      mobile: newMobileNumber ? newMobileNumber :  userData?.mobile?userData?.mobile:mobile ,
      firstName: newFirstName ? newFirstName : userData?.firstName ? userData?.firstName : firstName,
      lastName: newLastName ? newLastName : userData?.lastName ? userData?.lastName : lastName,
      studentName: newStudentName ? newStudentName : userData?.studentName ? userData?.studentName : studentName,
      courseFees: newCourseFees ? newCourseFees : userData?.courseFees ? userData?.courseFees : courseFees,
      courseName: newCourseName ? newCourseName :  userData?.courseName ? userData?.courseName : courseName,
      dateOfBirth: dob ? moment(dob).format('YYYY-MM-DD') :userData?.dob ? userData?.dob: dob,
      loanTenure: productType ? productType:  '',
      employmentType: empType,
      employerName: empType === "salaried" ? empName : "NA",
      salary: empType === "salaried" ? empSalary : "0",
      incomePerMonth: empType === "self-employed" ? empSalary : "0",
      typeOfBusiness: empType === "self-employed" ? empName : "NA",
      email: newEmail ? newEmail :  userData?.email ? userData?.email: email,
      maritalStatus: maritalStatus,
      
    };

    console.log("dataaaaaaaaaaaaasdsd",data)

    const combinedErrors = {};
    let flag = 0;

    const validateData = (dataObj) => {
      let localFlag = 0;
      let localErrors = {};
  
      for (const key in dataObj) {
        if (dataObj[key] === "") {
          localFlag = 1;
          localErrors[key] = "This is a required field";
        }
      }
  
      return { flag: localFlag, errors: localErrors };
    };

    const validationData = validateData(data)
    if (validationData.flag) {
      flag = 1;
      Object.assign(combinedErrors, validationData.errors);
    }

    const validationData1 = validateData(data1)


    if (validationData1.flag) {
      flag = 1;
      Object.assign(combinedErrors, validationData1.errors);
    }
  
    setErrors(combinedErrors);

    
  //   for(var key in data) {

  //     if(data[key] === "") {
  //       console.log("key",key)
  //       console.log("data[key]",data[key])
  //       flag=1
  //       tempError[key]="This is a required field"
  //     }
  //     // if(key==="courseFees"&&(parseInt(data[key])>35000))
  //     //   {
  //     //     flag=1
  //     //     tempError[key]="This is a required field and should be less than 35000Rs"
  //     //   }
  //     setErrors(tempError)
  // }


  if(flag!=1)
    { setLoading(true)
      await axiosInstance.post(updateAddress,data,{
        headers:{
          Authorization:`Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcHBsaWNhdGlvbnMtYmFja2VuZCIsInVzZXJfaWQiOjUsImVtYWlsIjoic2FpcmFta0BmZWVtb25rLmNvbSIsImlhdCI6MTcxNjg3Mzc4NjY5Nywicm9sZSI6ImNybSIsImRpc3BsYXlfbmFtZSI6IlNhaSBSYW0gUmVkZHkiLCJtb2JpbGUiOiI2MzA5MTQ4MzMzIiwiZXhwIjoxNzE2ODc0MzkxNDk3fQ.lPHnxTija-VpfqMzFWfJJ5fkHDkWJYM-kt2ybO7AgA8`
        }
      })
      .then((res)=>
      {
       
        let emidate=new Date()
          let current=null
          if (emidate.getMonth() == 11) {
            current = `${emidate.getFullYear() + 1}/01/05`
         } else {
            current = `${emidate.getFullYear()}/${emidate.getMonth() + 2}/05`
         }
       
        setTimeout(() => {
         
          const statusData = {
            applicationId:userData?.applicationId?userData?.applicationId:appId,
            fundCode: "GBP",
            productId: productCode,
            loanAmount: newCourseFees ? newCourseFees : userData?.courseFees ? userData?.courseFees : courseFees,
            emi: emiAmount,
            emiFirstDate:current,
            dayOfEmi: 5,
          };
    
          axiosInstance
            .post(`${updateStatusUrl}`, statusData, {
              headers: {
                Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcHBsaWNhdGlvbnMtYmFja2VuZCIsInVzZXJfaWQiOjUsImVtYWlsIjoic2FpcmFta0BmZWVtb25rLmNvbSIsImlhdCI6MTcxNjg3Mzc4NjY5Nywicm9sZSI6ImNybSIsImRpc3BsYXlfbmFtZSI6IlNhaSBSYW0gUmVkZHkiLCJtb2JpbGUiOiI2MzA5MTQ4MzMzIiwiZXhwIjoxNzE2ODc0MzkxNDk3fQ.lPHnxTija-VpfqMzFWfJJ5fkHDkWJYM-kt2ybO7AgA8`,
                'Content-type': 'application/json',
              },
            })
            .then(
              (res) => {
                if (res.data.message === 'Successful') {
                  setLoading(false)
                  window.location.reload();
               
                }
              },
              (error) => {
                setLoading(false)
              
             
              },
            );
        }, 1000);
    })
    }
    else if(errors.length>0)
    {
      alert(JSON.stringify(errors))
    }

  }

  return (
    
    <Modal
    open={formOpen}
    onClose={() => setFormOpen(!formOpen)}
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{ timeout: 500 }}
  >
   
      <Box sx={style}>
        {/* <Box sx={formHeader}>
          <Typography variant="h6">Complete Application</Typography>
          <CloseIcon onClick={() => setFormOpen(!formOpen)} />
        </Box> */}

        <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "8px",
                  padding: "10px 10px"
                }}
              >
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  sx={{
                    fontWeight: "500",
                    fontSize: "20px",
                  }}
                >
                 Complete Appl.
                </Typography>
                
                
                <CloseIcon onClick={() => setFormOpen(!formOpen)} />
              </Box>

        <Box sx={scrollableBody}>



        <Grid container spacing={2} >
           {/*other details start */}
          <Grid item xs = {12}>
        <Box sx={{ backgroundColor: '#F7FAFF', p: 2,border: '1px solid #F7FAFF',borderRadius:'8px',boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',mx: 2}}>
        <Grid container spacing={1}>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                {isFeemonk ? "Institute Name":"Company Name"}
                </Typography>
                <TextField
                  placeholder={isFeemonk ? "Institute Name":"Company Name"}
                  value={userData?.instituteName?userData?.instituteName:instituteName}
                  disabled
                  fullWidth
                  error={!!errors.instituteName}
                  helperText={errors.instituteName}
                  InputLabelProps={{
                    shrink: false
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  First Name
                </Typography>
                <TextField
                  placeholder="First Name"
                  defaultValue={userData?.firstName?userData?.firstName:firstName}
                  onChange={(e) => setNewFirstName( e.target.value)}
                  fullWidth
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Last Name
                </Typography>
                <TextField
                  placeholder="Last Name"
                  defaultValue={userData?.lastName?userData.lastName:lastName}
                  onChange={(e) => setNewLastName( e.target.value)}
                  fullWidth
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Mobile
                </Typography>
                <TextField
                  placeholder="Mobile"
                  value={userData?.mobile?userData.mobile:mobile}
                  onChange={(e) => setNewMobileNumber(e.target.value)}
                  fullWidth
                  error={!!errors.mobile}
                  helperText={errors.mobile}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Email
                </Typography>
                <TextField
                  placeholder="Email"
                  defaultValue={userData?.email?userData.email:email}
                  onChange={(e) => setNewEmail( e.target.value)}
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Date of Birth
                </Typography>
                <TextField
                  placeholder="Date of Birth"
                  defaultValue={userData?.dob?userData?.dob:dob}
                  type="date"
                  onChange={(e) => setDob( e.target.value)}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Gender
                </Typography>
                <TextField
                  placeholder="Gender"
                  value={userData?.gender?userData?.gender:gender}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Marital Status
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>{maritalStatus || userData?.maritalStatus?"":"Marital Status"}</InputLabel>
                  <Select
                    value={maritalStatus?maritalStatus:userData?.maritalStatus}
                    onChange={(e) => setMaritalStatus( e.target.value)}
                    error={!!errors.maritalStatus}
                  >
                    <MenuItem value="">
                      <em>Select Marital Status</em>
                    </MenuItem>
                    {maritalOptions?.map((item, index) => (
                      <MenuItem key={index} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.maritalStatus && (
                    <Typography color="error">{errors.maritalStatus}</Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  {isFeemonk ? "Course Name":"Product"}
                </Typography>
                <TextField
                  placeholder={isFeemonk ? "Course Name":"Product"}
                  defaultValue={userData?.courseName?userData.courseName:courseName}
                  onChange={(e) => setNewCourseName( e.target.value)}
                  fullWidth
                  error={!!errors.courseName}
                  helperText={errors.courseName}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Loan Amount
                </Typography>
                <TextField
                  placeholder="Loan Amount"
                  defaultValue={userData?.courseFees?userData.courseFees:courseFees}
                  onChange={(e) => setNewCourseFees( e.target.value)}
                  fullWidth
                  error={!!errors.courseFees}
                  helperText={errors.courseFees}
                  InputLabelProps={{
                    shrink: false
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Tenure
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>{productType ? "":"Tenure"}</InputLabel>
                  <Select
                   
                   onChange={(e) => {
                    const selectedTenure = e.target.value;
                    const filteredProducts = productId.filter(num =>
                      ["NWTSN120100", "NWTSN240200", "NWTSN180200", "NWTSN100100", "NWTSN06000F", "NWTSN03000F","NWTSN090100","NWTSN240200","NWTSN260200","NWTSV200200"].includes(num.name)
                    )
                    const selectedProduct = filteredProducts.find((num) => num.tenure === selectedTenure);                
                    if (selectedProduct) {
                      setProductCode(selectedProduct.productId);
                    }
                    
                    setProductType(selectedTenure);
                  }}
                    error={!!errors.loanTenure}
                  >
                    <MenuItem value="">
                      <em>Select Tenure</em>
                    </MenuItem>
                    {productId
                        .filter(num => 
                          ["NWTSN120100", "NWTSN240200", "NWTSN180200", "NWTSN100100","NWTSN06000F","NWTSN03000F","NWTSN090100","NWTSN240200","NWTSN260200","NWTSV200200"].includes(num.name)
                        )
                        .filter(num => num?.tenure <= newCourseFees / 3500)
                        .map((num, index) => (
                          <MenuItem key={`manual-${index}`} value={num.tenure}>
                            {num?.tenure} Months
                          </MenuItem>
                        ))
                      }
                    
                    {/* {prodArray?.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item.tenure} Months
                      </MenuItem>
                    ))} */}
                  </Select>
                  {errors.loanTenure && (
                    <Typography color="error">{errors.loanTenure}</Typography>
                  )}
                </FormControl>
              </Grid>                     
              <Grid item xs={3}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Student Name
                </Typography>
                <TextField
                  placeholder="Student Name"
                  defaultValue={studentName}
                  onChange={(e) => setNewStudentName( e.target.value)}
                  fullWidth
                  error={!!errors.studentName}
                  helperText={errors.studentName}
                />
              </Grid>              
              <Grid item xs={2.5}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Employment Type
                </Typography>
                <FormControl fullWidth>
                  <InputLabel>{empType || userData?.empType ? "":"Employment Type"}</InputLabel>
                  <Select
                    value={userData?.empType?userData?.empType:empType}
                    onChange={(e) => setEmpType( e.target.value)}
                    error={!!errors.employmentType}
                  >
                    <MenuItem value="">
                      <em>Select Employment</em>
                    </MenuItem>
                    <MenuItem value="salaried">Salaried</MenuItem>
                    <MenuItem value="self-employed">Self-Employed</MenuItem>
                  </Select>
                  {errors.employmentType && (
                    <Typography color="error">{errors.employmentType}</Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={2.5}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Employer Name
                </Typography>
                <TextField
                  placeholder="Employer Name"
                  
                  onChange={(e) =>setEmpName(e.target.value)}
                  fullWidth
                  error={!!errors.employerName}
                  helperText={errors.employerName}
                />
              </Grid>
              <Grid item xs={2.5}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Salary
                </Typography>
                <TextField
                  placeholder="Salary"
                  defaultValue={userData?.salary?userData?.salary:salary}
                  onChange={(e) => setEmpSalary( e.target.value)}
                  fullWidth
                  error={!!errors.salary}
                  helperText={errors.salary}
                />
              </Grid>
              <Grid item xs={2.5}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Aadhaar Number
                </Typography>
                <TextField
                  placeholder="Aadhaar Number"
                  value={userData?.aadhaarId?userData?.aadhaarId:aadhaarId}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Pan Number
                </Typography>
                <TextField
                  placeholder="Pan Number"
                  value={userData?.panId?userData?.panId:panId}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="center" mt={2}>
                <Button variant="contained" sx={{bgcolor:'#d32028',color:'white'}} onClick={handleSave}> SAVE
                </Button>
              </Grid>
             
              <Box></Box>
            </Grid>  
              </Box>
          </Grid>    
          <Grid item xs={12}>
            <Box sx={{ backgroundColor: '#F7FAFF', p: 4,border: '1px solid #F7FAFF',borderRadius:'8px',boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',mx: 2}}>
            <Grid container >
              <Grid item xs={12} textAlign="center" sx={{mt:-4}}>
                <h2>Drag and Drop or Upload</h2>
                </Grid>
              <Grid item xs={3}>
                <Dropzone
                  onDrop={handleFileDrop(setAadhaarFront, "aadhaar_front")}
                  accept={{ "image/jpeg": [], "image/png": [] }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section className={styles.uploadBox}>
                      <div {...getRootProps()} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <img src={aadhaar} style={{height:'5rem'}}/>
                        <p>Aadhaar Front</p>
                        <input {...getInputProps()} />
                        <CloudUploadIcon/>
                      </div>
                      {aadhaarFront && (
                <div style={{ fontSize: '0.9rem', display: 'flex', alignItems: 'center',justifyContent:'center' }}>
                  <p style={{ marginRight: '10px' }}>{aadhaarFront.name}</p>
                  <DeleteIcon
                    style={{ cursor: 'pointer', color: 'red' }}
                    onClick={handleFileRemove(setAadhaarFront)}
                  />
                </div>
              )}                    </section>
                  )}
                </Dropzone>
              </Grid>
              <Grid item xs={3}>
                <Dropzone
                  onDrop={handleFileDrop(setAadhaarBack, "aadhaar_back")}
                  accept={{ "image/jpeg": [], "image/png": [] }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section className={styles.uploadBox}>
                      <div {...getRootProps()} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <img src={aadhaar} style={{height:'5rem'}}/>
                        <p>Aadhaar Back</p>
                        <input {...getInputProps()} />
                        <CloudUploadIcon/>
                      </div>
                      {aadhaarBack && (
                <div style={{fontSize: '0.9rem', display: 'flex', alignItems: 'center',justifyContent:'center' }}>
                  <p style={{ marginRight: '10px' }}>{aadhaarBack.name}</p>
                  <DeleteIcon
                    style={{ cursor: 'pointer', color: 'red' }}
                    onClick={handleFileRemove(setAadhaarBack)}
                  />
                </div>
              )}                    </section>
                  )}
                </Dropzone>
              </Grid>
              <Grid item xs={3}>
                <Dropzone
                  onDrop={handleFileDrop(setPanCard, "pan")}
                  accept={{ "image/jpeg": [], "image/png": [] }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section className={styles.uploadBox}>
                      <div {...getRootProps()} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <img src={pan}style={{height:'4.5rem',marginTop:'0.4rem'}}/>
                        <p>PAN</p>
                        <input {...getInputProps()} />
                        <CloudUploadIcon/>
                      </div>
                      {panCard && (
                <div style={{  fontSize: '0.9rem', display: 'flex', alignItems: 'center' ,justifyContent:'center'}}>
                  <p style={{ marginRight: '10px' }}>{panCard.name}</p>
                  <DeleteIcon
                    style={{ cursor: 'pointer', color: 'red' }}
                    onClick={handleFileRemove(setPanCard)}
                  />
                </div>
              )}                   
               </section>
                  )}
                </Dropzone>
              </Grid>
              <Grid item xs={3}>
                <Dropzone
                  onDrop={handleFileDrop(setBankStatement , "pdf")}
                   accept=".pdf"
                >
                  {({ getRootProps, getInputProps }) => (
                    <section className={styles.uploadBox}>
                      <div {...getRootProps()} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                        <img src={bs} style={{height:empType?'4rem':'5rem',width:'8rem'}}/>
                        <p>Bank Statement<br/>
                        </p>
                       <p style={{marginTop:'-15px',whiteSpace:'nowrap'}}> {empType === "salaried" ? "(Please Upload Atleast Last 3 Months Statement)":empType === "self-employed" ? "(Upload Atleast Last 6 Months Statement)":""}
                       </p> 
                        <input {...getInputProps()} />
                        <CloudUploadIcon/>
                      </div>
                      {bankStatement && (
                <div style={{  fontSize: '0.9rem', display: 'flex', alignItems: 'center' ,justifyContent:'center'}}>
                  <p style={{ marginRight: '10px' }}>{bankStatement.name}</p>
                  <DeleteIcon
                    style={{ cursor: 'pointer', color: 'red' }}
                    onClick={handleFileRemove(setBankStatement)}
                  />
                </div>
              )}           
              {errorMessage && (
                  <p style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>{errorMessage}</p>
                )}        

                 {isBankStatementUploaded && (
                  <div style={{ textAlign: 'center',display:'flex',alignItems:'center' }}>
                    <label htmlFor="password">Enter Password (if any)</label>
                    <TextField
                            placeholder="password"
                            fullWidth
                            style={{ width: '190px', marginTop: '10px' }}
                            onChange={(e) => setPassword( e.target.value)}
                          />
                  </div>
                )}
               </section>
                  )}
                </Dropzone>
              </Grid>
              <Grid item xs={12} display="flex" justifyContent="center" mt={4}>
                <Button variant="contained" sx={{bgcolor:'#d32028',color:'white'}}  onClick={() => {
                      handleUpload();
                    }} disabled={!aadhaarFront || !panCard}> 
                 {uploadLoading
        ? "SAVING"
        : "SAVE"}
                </Button>
              </Grid>
              </Grid>
            </Box>
          </Grid>
              {/* Application Address */}
              <Grid item xs={6}>
              <Box sx={{ backgroundColor: '#F7FAFF', p: 4,border: '1px solid #F7FAFF',borderRadius:'8px',boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',ml: 2,mb:2}}>
                <Typography variant="h6">PERMANENT ADDRESS</Typography>
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Address
                </Typography>
                <TextField
                  placeholder="Address"
                  value={ocrData?.address || ""}
                  onChange={(e) =>
                    setOcrData((prev) => ({
                      ...prev,
                      address: e.target.value,
                    }))
                  }                  
                  fullWidth
                  error={!!errors.currentAddress}
                  helperText={errors.currentAddress}
                  sx={{ mb: 2 }}
                />
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography
                      as="h5"
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        mb: '12px',
                      }}
                    >
                      City
                    </Typography>
                    <TextField
                      placeholder="City"
                      value={ocrData?.city || ""}
                      onChange={(e) =>
                        setOcrData((prev) => ({
                          ...prev,
                          city: e.target.value,
                        }))
                      }
                      fullWidth
                      error={!!errors.currentCity}
                      helperText={errors.currentCity}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      as="h5"
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        mb: '12px',
                      }}
                    >
                      State
                    </Typography>
                    <TextField
                      placeholder="State"
                      value={ocrData?.state || ""}
                      onChange={(e) =>
                        setOcrData((prev) => ({
                          ...prev,
                          state: e.target.value,
                        }))
                      }
                      fullWidth
                      error={!!errors.currentState}
                      helperText={errors.currentState}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      as="h5"
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        mb: '12px',
                      }}
                    >
                      Pin Code
                    </Typography>
                    <TextField
                      placeholder="Pin Code"
                      value={ocrData?.pincode || ""}
                      onChange={(e) =>
                        setOcrData((prev) => ({
                          ...prev,
                          pincode: e.target.value,
                        }))
                      }
                      fullWidth
                      error={!!errors.currentZip}
                      helperText={errors.currentZip}
                    />
                  </Grid>
                </Grid>
              </Box>
              </Grid>
              {/* Office Address */}
              <Grid item xs={6}>
              <Box sx={{ backgroundColor: '#F7FAFF', p: 4,border: '1px solid #F7FAFF',borderRadius:'8px',boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',mr: 2}}>
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:'-10px'}}>
                <Typography variant="h6">CURRENT ADDRESS</Typography>
                   <Typography>
                   <FormControlLabel
                    control={
                      <Checkbox
                        checked={isSameAsPermanent}
                        onChange={handleCheckboxChange}
                        color="primary"
                      />
                    }
                    label="Same as Permanent Address"
                   
                  />
                   </Typography>
                </div>
               
                
                <Typography
                  as="h5"
                  sx={{
                    fontWeight: '500',
                    fontSize: '14px',
                    mb: '12px',
                  }}
                >
                  Address
                </Typography>
                <TextField
                  placeholder="Address"
                  value={isSameAsPermanent?ocrData?.address:permanentAddress}
                  onChange={(e) => setPermanentAddress( e.target.value)}
                  fullWidth
                  error={!!errors.officeAddress}
                  helperText={errors.officeAddress}
                  sx={{ mb: 2 }}
                />
                
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography
                      as="h5"
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        mb: '12px',
                      }}
                    >
                      City
                    </Typography>
                    <TextField
                      placeholder="City"
                      value={isSameAsPermanent?ocrData?.city:permanentCity}
                      onChange={(e) => setPermanentCity( e.target.value)}
                      fullWidth
                      error={!!errors.officeCity}
                      helperText={errors.officeCity}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      as="h5"
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        mb: '12px',
                      }}
                    >
                      State
                    </Typography>
                    <TextField
                      placeholder="State"
                      value={isSameAsPermanent?ocrData?.state:permanentState}
                      onChange={(e) => setPermanentState( e.target.value)}
                      fullWidth
                      error={!!errors.officeState}
                      helperText={errors.officeState}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      as="h5"
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        mb: '12px',
                      }}
                    >
                      Pin Code
                    </Typography>
                    <TextField
                      placeholder="Pin Code"
                      value={isSameAsPermanent?ocrData?.pincode:permanentPincode}
                      onChange={(e) => setPermanentPincode(e.target.value)}
                      fullWidth
                      error={!!errors.officePincode}
                      helperText={errors.officePincode}
                    />
                  </Grid>
                </Grid>
              </Box>
             </Grid>
             {saveError && (
                  <Grid item xs={12} textAlign="center" mt={1}>
                    <Typography color="error">{saveError}</Typography>
                  </Grid>
                )}
             <Grid item xs={12} display="flex" justifyContent="center">
                <Button variant="contained" sx={{bgcolor:'#d32028',color:'white'}} onClick={handleSubmit}> SUBMIT
                </Button>
              </Grid>
              
            </Grid>
        
        </Box>

       
      </Box>
 
  </Modal>

      
      
   
  );
}